module.exports = "<ion-content>\n\n  <img src=\"assets/img/Splashanimation.gif\" class=\"mysplash\" />\n\n</ion-content>\n"